import React, {JSX, useEffect, useState} from 'react';
import {Box, Collapse, Grid2, IconButton, ListItem, Select, Typography} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import dayjs, { Dayjs } from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Badge from '@mui/material/Badge';
import { PickersDay, PickersDayProps } from '@mui/x-date-pickers/PickersDay';
import { DayCalendarSkeleton } from '@mui/x-date-pickers/DayCalendarSkeleton';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { supabase } from '../components/supabaseClient.tsx';
import { StaticDateTimePicker } from '@mui/x-date-pickers/StaticDateTimePicker';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import TextField from '@mui/material/TextField';
import Alert from "@mui/material/Alert";
import CloseIcon from "@mui/icons-material/Close";
import AlertTitle from "@mui/material/AlertTitle";
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import Checkbox from '@mui/material/Checkbox';
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import CakeIcon from '@mui/icons-material/Cake';
import AutoDeleteIcon from '@mui/icons-material/AutoDelete';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';

const initialValue = dayjs();

interface Kalenderinterface {
    id: number;
    created_at: string;
    Titel: string;
    Description: string;
    Date: string;
    Time: string;
    User: string;
    Category: number;
}
function ServerDay(props: PickersDayProps<Dayjs> & { highlightedDays?: number[], onClick: (event: React.MouseEvent<HTMLButtonElement>, day: Dayjs) => void }) {
    const { highlightedDays = [], day, outsideCurrentMonth, onClick, ...other } = props;

    const isSelected =
        !props.outsideCurrentMonth && highlightedDays.indexOf(props.day.date()) >= 0;

    return (
        <Badge
            key={props.day.toString()}
            overlap="circular"
            badgeContent={isSelected ? '🚩' : undefined}
        >
            <PickersDay
                {...other}
                outsideCurrentMonth={outsideCurrentMonth}
                day={day}
                onClick={(event) => onClick(event, day)}
            />
        </Badge>
    );
}

function getCategoryIcon(category: number) {
    switch (category) {
        case 1:
            return <CalendarMonthIcon />;
        case 2:
            return <CakeIcon />;
        case 3:
            return <AutoDeleteIcon />;
        case 4:
            return <MedicalServicesIcon />;
        default:
            return <InsertInvitationIcon />;
    }
}

export default function Calendar() {
    const [isLoading, setIsLoading] = React.useState(false);
    const [highlightedDays, setHighlightedDays] = React.useState([]);
    const [selectedDate, setSelectedDate] = React.useState<Dayjs | null>(null);
    let kalenderforhighliteddays: Kalenderinterface[] = [];
    let requestAbortController: { current: AbortController | null } = { current: null };
    let currentMonth: number = dayjs().month() + 1;
    let currentYear: number = dayjs().year();
    const [isDialogOpen, setIsDialogOpen] = React.useState(false);
    const [neuerTermin, setNeuerTermin] = React.useState<Kalenderinterface>({} as Kalenderinterface);
    const [alert, setAlert] = useState<JSX.Element | null>(null);
    const [open, setOpen] = React.useState(true);
    const [kalender, setKalender] = React.useState<Kalenderinterface[]>([]);
    const [openen, setOpenen] = React.useState(true);
    const [monthopen, setMonthopen] = React.useState(true);
    const [yearEvent, setYearEvent] = React.useState<Kalenderinterface[]>([]);
    const [checked, setChecked] = React.useState([]);
    const [selectedIndex, setSelectedIndex] = React.useState(1);
    const [selectedEvent, setSelectedEvent] = React.useState<Kalenderinterface | null>(null);
    const [bearbeitenTermin, setbearbeitenTermin] = React.useState<Kalenderinterface>({} as Kalenderinterface);
    const [IsEditDialogOpen, setIsEditDialogOpen] = React.useState(false);
    const [openMonths, setOpenMonths] = useState<{ [key: number]: boolean }>({});
    const [isShowDialogOpen, setIsShowDialogOpen] = React.useState(false);
    const [selectedCategory, setSelectedCategory] = React.useState<number>(0);

    const handleToggle = (event: Kalenderinterface) => {
        const currentIndex = checked.indexOf(event.id);
        const newChecked = [...checked];
        if (currentIndex === -1) {
            newChecked.push(event.id);
        } else {
            newChecked.splice(currentIndex, 1);
        }
        console.log(newChecked);
        setChecked(newChecked);
    };

    const handleListItemClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, eventItem: Kalenderinterface) => {
        if (selectedEvent?.id === eventItem.id) {
            setSelectedEvent(null);
        } else {
            setSelectedEvent(eventItem);
        }
    };

    const handleListItemShow = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, eventItem: Kalenderinterface) => {
        setSelectedEvent(eventItem);
        setIsShowDialogOpen(true);
    };

    const handleMonthopen = (month: number) => {
        setOpenMonths(prev => ({ ...prev, [month]: !prev[month] }));
    };


    const handleClick = () => {
        setOpenen(!openen);
    };

    const handleEditEvent = () => {
        if (checked.length === 1) {
            const eventToEdit = yearEvent.find(event => event.id === checked[0]);
            if (eventToEdit) {
                setbearbeitenTermin(eventToEdit);
                setIsEditDialogOpen(true);
            }
        }
    };

    const updateEvent = async () => {
        try {
            console.log(bearbeitenTermin);
            const { data, error } = await supabase
                .from('Kalender')
                .update(bearbeitenTermin)
                .eq('id', bearbeitenTermin.id);

            if (error) {
                throw error;
            }

            setIsEditDialogOpen(false);
            setAlert(
                <Collapse in={open} style={{ position: 'absolute', top: '50px', right: '20px', zIndex: 1000 }}>
                    <Alert
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    setOpen(false);
                                    setAlert(null);
                                }}
                            >
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                        sx={{ mb: 2 }}
                        severity={"success"}
                    >
                        <AlertTitle>Success</AlertTitle>
                        Event updated successfully!
                    </Alert>
                </Collapse>
            );

            setYearEvent(yearEvent.map(event => event.id === bearbeitenTermin.id ? bearbeitenTermin : event));
            setSelectedEvent(null);
        } catch (error) {
            setAlert(
                <Collapse in={open} style={{ position: 'absolute', top: '50px', right: '20px', zIndex: 1000 }}>
                    <Alert
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    setOpen(false);
                                    setAlert(null);
                                }}
                            >
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                        sx={{ mb: 2 }}
                        severity={"error"}
                    >
                        <AlertTitle>Error</AlertTitle>
                        Something went wrong!
                    </Alert>
                </Collapse>
            );
        }
    };


    const handleDeleteEvent = async () => {
        if (checked.length > 0) {
            try {
                const { error } = await supabase
                    .from('Kalender')
                    .delete()
                    .in('id', checked);

                if (error) {
                    throw error;
                }

                setAlert(
                    <Collapse in={open} style={{ position: 'absolute', top: '50px', right: '20px', zIndex: 1000 }}>
                        <Alert
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setOpen(false);
                                        setAlert(null);
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                            sx={{ mb: 2 }}
                            severity={"success"}
                        >
                            <AlertTitle>Success</AlertTitle>
                            Event(s) deleted successfully!
                        </Alert>
                    </Collapse>
                );

                setYearEvent(yearEvent.filter(event => !checked.includes(event.id)));
                setChecked([]);
                setSelectedEvent(null);
            } catch (error) {
                setAlert(
                    <Collapse in={open} style={{ position: 'absolute', top: '50px', right: '20px', zIndex: 1000 }}>
                        <Alert
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setOpen(false);
                                        setAlert(null);
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                            sx={{ mb: 2 }}
                            severity={"error"}
                        >
                            <AlertTitle>Error</AlertTitle>
                            Something went wrong!
                        </Alert>
                    </Collapse>
                );
            }
        }
    };

    const getLastDayOfMonth = (year: number, month: number) => {
        return new Date(year, month, 0).getDate();
    };

    const saveNewEvent = async () => {
        try {
            console.log(neuerTermin);
            const { data} = await supabase
                .from('Kalender')
                .insert([neuerTermin]);

            setIsDialogOpen(false);
            setAlert(
                <Collapse in={open} style={{ position: 'absolute', top: '50px', right: '20px', zIndex: 1000 }}>
                    <Alert
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    setOpen(false);
                                    setAlert(null);
                                }}
                            >
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                        sx={{ mb: 2 }}
                        severity={"success"}
                    >
                        <AlertTitle>Success</AlertTitle>
                        Event saved successfully!
                    </Alert>
                </Collapse>
            );
            return data;
        } catch (error) {
            setAlert(
                <Collapse in={open} style={{ position: 'absolute', top: '50px', right: '20px', zIndex: 1000 }}>
                    <Alert
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    setOpen(false);
                                    setAlert(null);
                                }}
                            >
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                        sx={{ mb: 2 }}
                        severity={"error"}
                    >
                        <AlertTitle>Error</AlertTitle>
                        Something went wrong!
                    </Alert>
                </Collapse>
            );
            return null;
        }
    }


    const loadKalenderByMonth = async (year: number, month: number) => {
        const lastDay = getLastDayOfMonth(year, month);
        const { data} = await supabase
            .from('Kalender')
            .select('*')
            .gte('Date', `${year}-${month}-01`)
            .lte('Date', `${year}-${month}-${lastDay}`);
        kalenderforhighliteddays = data || [];
        setKalender(data || []);
    };

    const loadKalenderByYear = async () => {
        const year = dayjs().year();
        const { data} = await supabase
            .from('Kalender')
            .select('*')
            .gte('Date', `${year}-01-01`)
            .lte('Date', `${year}-12-31`);
        setYearEvent(data || []);
    };

    const handleMonthChange = async (date: Dayjs) => {
        if (requestAbortController.current) {
            requestAbortController.current.abort();
        }
        currentMonth = date.month() + 1;
        currentYear = date.year();

        try {
            setIsLoading(true);
            setHighlightedDays([]);
            // Fetch calendar entries for the selected month and year
            await loadKalenderByMonth(currentYear, currentMonth).then(r => setHighlightedDays(kalenderforhighliteddays.map((kalenderforhighliteddays) => dayjs(kalenderforhighliteddays.Date).date())));
            // Update highlighted days
        } catch (error) {
            console.error("Error loading calendar entries:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        const fetchInitialEntries = async () => {
            setIsLoading(true);
            await loadKalenderByMonth(currentYear, currentMonth).then(r => setHighlightedDays(kalenderforhighliteddays.map((kalenderforhighliteddays) => dayjs(kalenderforhighliteddays.Date).date())));
            await loadKalenderByYear();
            setIsLoading(false);
        };
        fetchInitialEntries();
    }, []);

    const handleDayClick = (event: React.MouseEvent<HTMLButtonElement>, day: Dayjs) => {
        setSelectedDate(day);
    };

    const handleNewEvent = () => {
        setIsDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setIsDialogOpen(false);
        setSelectedCategory(0);
    };

    const handleCloseShowDialog = () => {
        setIsShowDialogOpen(false);
    };

    const handleCloseEditDialog = () => {
        setIsEditDialogOpen(false);
    };

    const eventsByMonth = yearEvent.filter(event => dayjs(event.Date).year() === currentYear)
        .reduce((acc, event) => {
            const month = dayjs(event.Date).month();
            if (!acc[month]) {
                acc[month] = [];
            }
            acc[month].push(event);
            return acc;
        }, {} as { [key: number]: Kalenderinterface[] });

    return (
        <div style={{width:'3300px', height:'800px'}}>
            <div style={{
                position: 'absolute',
                top: '20px',
                right: '20px',
                zIndex: 1000,
            }}>
                {alert}
            </div>
        <Grid2 container spacing={2} style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', flexDirection:'row'}}>
            <Grid2 style={{ width: 'auto', height: 'auto', paddingLeft: '5px' }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateCalendar
                        defaultValue={initialValue}
                        views={['year', 'month', 'day']}
                        loading={isLoading}
                        onMonthChange={handleMonthChange}
                        renderLoading={() => <DayCalendarSkeleton />}
                        slots={{
                            day: (props) => <ServerDay {...props} onClick={handleDayClick} />,
                        }}
                        slotProps={{
                            day: {
                                highlightedDays,
                            } as any,
                        }}
                    />
                </LocalizationProvider>
            </Grid2>
            <Grid2 style={{ width: 'auto', height: 'auto', paddingLeft: '10px'}}>
                <List
                    sx={{
                        width: '400px',
                        bgcolor: 'background.paper',
                        position: 'relative',
                        overflow: 'auto',
                        maxHeight: '1000px',
                        '& ul': { padding: 0 },
                    }}
                >
                    {yearEvent.length === 0 ? (
                        <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                            <Typography variant="body1">No Dates this Year</Typography>
                        </Box>
                    ) : (

                        Object.keys(eventsByMonth).map(month => (
                        <List key={`section-${month}`}>
                            <ListItemButton onClick={() => handleMonthopen(parseInt(month))}>
                                <ListItemIcon>
                                    <CalendarMonthIcon />
                                </ListItemIcon>
                                <ListItemText primary={dayjs().month(parseInt(month)).format('MMMM')} />
                                {openMonths[parseInt(month)] ? <ExpandLess /> : <ExpandMore />}
                            </ListItemButton>
                            <Collapse in={openMonths[parseInt(month)]} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                    {eventsByMonth[parseInt(month)].map((event) => (
                                        <ListItem
                                            key={event.id}
                                            secondaryAction={
                                                <IconButton edge="end" aria-label="comments">
                                                    {getCategoryIcon(event.Category)}
                                                </IconButton>
                                            }
                                            disablePadding
                                        >
                                            <React.Fragment key={event.id}>
                                        <ListItemButton
                                            key={event.id}
                                            onClick={(e) => handleListItemShow(e, event)}
                                        >
                                            <ListItemIcon>
                                                <Checkbox
                                                    edge="start"
                                                    checked={checked.includes(event.id)}
                                                    tabIndex={-1}
                                                    disableRipple
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleToggle(event);
                                                    }}
                                                />
                                            </ListItemIcon>
                                            <ListItemText primary={`${event.Titel} - ${dayjs(event.Date).format('DD.MM.YYYY')}`}/>
                                        </ListItemButton>
                                            </React.Fragment>
                                        </ListItem>
                                    ))}
                                </List>
                            </Collapse>
                        </List>
                    ))
                    )}
                </List>
            </Grid2>
            <Grid2 style={{ width: 'auto', height: 'auto', paddingLeft: '2px'}}>
                <Button
                    variant="contained"
                    endIcon={<InsertInvitationIcon />}
                    onClick={handleNewEvent}
                    style={{width: '70%', height: '50px'}}
                >
                    New Date
                </Button>
                <Button
                    variant="contained"
                    endIcon={<EventBusyIcon />}
                    color="primary"
                    onClick={handleDeleteEvent}
                    disabled={checked.length === 0}
                    style={{ width: '70%', height: '50px', marginTop: '10px' }}
                >
                    Delete Date/s
                </Button>
                <Button
                    variant="contained"
                    endIcon={<EditCalendarIcon />}
                    color="primary"
                    onClick={handleEditEvent}
                    disabled={checked.length !== 1}
                    style={{ width: '70%', height: '50px', marginTop: '10px' }}
                >
                    Edit Date
                </Button>
            </Grid2>
            <Grid2 style={{ width: 'auto', height: 'auto', paddingLeft: 700 }}>
                <Dialog open={isDialogOpen} onClose={handleCloseDialog} maxWidth="lg" fullWidth>
                    <DialogTitle style={{display: 'flex', justifyContent: 'center', alignItems: 'center',}}>New Date</DialogTitle>
                    <DialogContent>
                        <Grid2 spacing={2} display={"flex"} justifyContent={"space-between"}>
                            <Grid2 style={{paddingLeft:'80px'}}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <StaticDateTimePicker defaultValue={dayjs()} ampm={false} views={['year', 'month', 'day', 'hours', 'minutes']} onAccept={(date) => {
                                        setNeuerTermin((prev: any) => ({
                                            ...prev,
                                            Date: date.format('YYYY-MM-DD'),
                                            Time: date.format('HH:mm'),
                                        }));
                                    }}/>
                                </LocalizationProvider>
                            </Grid2>
                            <Grid2 style={{paddingRight: '100px', marginTop: '100px'}} >
                                <Grid2>
                                <TextField
                                    id="outlined-password-input"
                                    label="Date-Titel"
                                    type="text"
                                    autoComplete="Date Titel"
                                    style={{width: '500px', height: '50px'}}
                                    onChange={(e) => { setNeuerTermin((prev) => ({ ...prev, Titel: e.target.value })); }}
                                />
                                </Grid2>
                                <Grid2 style={{paddingTop:'30px'}}>
                                <TextField
                                    id="outlined-textarea"
                                    label="Date-Description"
                                    placeholder="Describe your Date"
                                    multiline
                                    rows={6}
                                    style={{width: '500px'}}
                                    onChange={(e) => { setNeuerTermin((prev) => ({ ...prev, Description: e.target.value })); }}
                                />
                                </Grid2>
                                <Grid2 style={{paddingTop:'30px'}}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Category</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={selectedCategory}
                                            label="Category"
                                            onChange={(e) => {
                                                setSelectedCategory(Number(e.target.value));
                                                setNeuerTermin((prev) => ({ ...prev, Category: Number(e.target.value) }));
                                            }}
                                        >
                                            <MenuItem value={1}>Date</MenuItem>
                                            <MenuItem value={2}>Birthday</MenuItem>
                                            <MenuItem value={3}>Garbage collection</MenuItem>
                                            <MenuItem value={4}>Medical Date</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid2>
                            </Grid2>
                        </Grid2>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={saveNewEvent}>Save</Button>
                        <Button onClick={handleCloseDialog}>Close</Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={IsEditDialogOpen} onClose={handleCloseEditDialog} maxWidth="lg" fullWidth>
                    <DialogTitle style={{display: 'flex', justifyContent: 'center', alignItems: 'center',}}>
                        Edit Date
                    </DialogTitle>
                    <DialogContent>
                        <Grid2 spacing={2} display={"flex"} justifyContent={"space-between"}>
                            <Grid2 style={{paddingLeft:'80px'}}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <StaticDateTimePicker
                                        defaultValue={dayjs(bearbeitenTermin.Date + 'T' + bearbeitenTermin.Time)}
                                        ampm={false}
                                        views={['year', 'month', 'day', 'hours', 'minutes']}
                                        onAccept={(date) => {
                                            setbearbeitenTermin((prev: any) => ({
                                                ...prev,
                                                Date: date.format('YYYY-MM-DD'),
                                                Time: date.format('HH:mm'),
                                            }));
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid2>
                            <Grid2 style={{paddingRight: '100px', marginTop: '100px'}} >
                                <Grid2>
                                    <TextField
                                        id="outlined-password-input"
                                        label="Date-Titel"
                                        type="text"
                                        autoComplete="Date Titel"
                                        value={bearbeitenTermin.Titel || ''}
                                        style={{width: '500px', height: '50px'}}
                                        onChange={(e) => { setbearbeitenTermin((prev) => ({ ...prev, Titel: e.target.value })); }}
                                    />
                                </Grid2>
                                <Grid2 style={{paddingTop:'30px'}}>
                                    <TextField
                                        id="outlined-textarea"
                                        label="Date-Description"
                                        placeholder="Describe your Event"
                                        multiline
                                        rows={6}
                                        value={bearbeitenTermin.Description || ''}
                                        style={{width: '500px'}}
                                        onChange={(e) => { setbearbeitenTermin((prev) => ({ ...prev, Description: e.target.value })); }}
                                    />
                                </Grid2>
                                <Grid2 style={{paddingTop:'30px'}}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Category</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={bearbeitenTermin.Category || 0}
                                            label="Category"
                                            onChange={(e) => {
                                                setSelectedCategory(Number(e.target.value));
                                                setbearbeitenTermin((prev) => ({ ...prev, Category: Number(e.target.value) }));
                                            }}
                                        >
                                            <MenuItem value={1}>Date</MenuItem>
                                            <MenuItem value={2}>Birthday</MenuItem>
                                            <MenuItem value={3}>Garbage collection</MenuItem>
                                            <MenuItem value={4}>Medical Date</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid2>
                            </Grid2>
                        </Grid2>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={updateEvent}>Update</Button>
                        <Button onClick={handleCloseEditDialog}>Close</Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={isShowDialogOpen} onClose={handleCloseShowDialog} maxWidth="sm" fullWidth>
                    <DialogTitle>
                        {selectedEvent?.Titel}
                        <div style={{ position: 'absolute', top: '10px', right: '10px' }}>
                            {selectedEvent && getCategoryIcon(selectedEvent.Category)}
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        <Typography variant="body1" gutterBottom>
                            {selectedEvent?.Description}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            Date: {dayjs(selectedEvent?.Date).format('DD.MM.YYYY')}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            Time: {selectedEvent?.Time}
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseShowDialog} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </Grid2>
        </Grid2>
        </div>

    );
}